/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wwg-mediagallery',
  templateUrl: './media-gallery.component.html',
  styleUrls: ['./media-gallery.component.scss']
})
export class MediaGalleryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
